import React, {Component} from 'react';
import LayoutAdvanced from '../components/LayoutAdvanced.jsx';

/*
import Map from '../components/Map.jsx';
import NavigatorAdvanced from '../components/NavigatorAdvanced.jsx';

const plugin = new M.plugin.Mapaalacarta({enabled: true});
const xylocator = new M.plugin.XYLocator();
const ignsearch = new M.plugin.IGNSearch(2, 10);
const fullviewmap = new M.plugin.FullViewMap({
  position: 'BL',
});
const scaleZoomPlugin = new M.plugin.ScaleZoom(plugin);
const insertPhotoPlugin = new M.plugin.InsertPhoto({
  position: 'BL',
});
const pluginList = [plugin, ignsearch, xylocator, scaleZoomPlugin, fullviewmap, insertPhotoPlugin];
*/

// http://localhost:3000/mapaalacarta/DataForPrint?active=3

class Step4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paperTypePrice: "11.50",
      presentationPrice: "5.25",
      numberOfCopies: "1",
      paperType: "Normal",
      presentation: "Plegado",
      totalPrice: 16.75,
      centerX: -417002.20780977904,
      centerY: 4931965.4853014955,
    };
  }

  functionPost() {
    /* if(!this.conversor){
      // this.props.parentState.center = [ -408794.85916320374, 4930226.47067901 ];
      this.props.parentState.isSimple = true;
      this.props.setParentStateSteps(this.props.parentState);
      this.conversor = JSON.stringify(this.props.conversorStateToMapfish(this.props.parentState, 'Elaborado'));
    } */
    var xhr = new XMLHttpRequest();
    xhr.open("POST", "https://9308f2b1-eef8-4204-a630-667bf406bd16.mock.pstmn.io/newMap", true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(this.conversor));
    xhr.onload = () => {
      console.log("MOCK:", xhr.response); // JSON.parse("{Success: Map created}") causa errror al no ser '{"Success":"Map created"}'
      this.convers = xhr.response;
      this.props.setParentState(this.props.parentState);
    }
  }
  //AÑADIR ESTO PARA EL NAVIGATOR
  setStateGlobal = (parentState) => {
    const {setParentState} = this.props;

    setParentState(parentState);
  }
  setStateGlobalStep = (state) => {
    const {setParentStateSteps} = this.props;
    setParentStateSteps(state);
  }
  // ESTO VA EN EL RETURN, EL NAVIGATOR

  render() {

    const {parentState, converterDecimalToDMS} = this.props;
    const coordPrev = -401225.797049155; // parentState.coordinates[0][1][1][0];
    const coords = converterDecimalToDMS(coordPrev);
    /*const {centerX, centerY} = this.state;

    //Left navigator
    const leftFirstDivClassName = 'wizard-1';
    const leftSecondDivClassName = 'circle bg-active';
    const leftTextSecondDivClassName = 'mc-design mc-2x';
    const leftLabelClassNameTittle = 'step-name active';
    const leftLabelTextTittle = 'DISEÑO DEL MAPA';
    const leftLabelClassNameDescription = 'step-description';
    const leftLabelDescription = 'Configure los contenidos a su medida';
    const leftBarClassName = 'bar bg-active';

    //Center navigator
    const centerFirstDivClassName = 'wizard-2';
    const centerSecondDivClassName = 'circle bg-active';
    const centerTextSecondDivClassName = 'mc-map mc-2x';
    const centerLabelClassNameTittle = 'step-name active';
    const centerLabelTextTittle = 'DISEÑO DE LA PORTADA';
    const centerLabelClassNameDescription = 'step-description';
    const centerLabelDescription = 'Personalice la información del mapa';
    const rightBarClassName = 'bar bg-active';

    //Right navigator
    const rightFirstDivClassName = 'wizard-3';
    const rightSecondDivClassName = 'circle bg-active';
    const rightTextSecondDivClassName = 'mc-pin-check mc-2x';
    const rightLabelClassNameTittle = 'step-name active';
    const rightLabelTextTittle = 'RESUMEN';
    const rightLabelClassNameDescription = 'step-description';
    const rightLabelDescription = 'Descargue y adquiera los resultados';

    const stepClassName = 'step1'
    const sectionClassName = 's1-left';*/

    return (<LayoutAdvanced setParentStateSteps={this.setStateGlobal} parentState={parentState} nextPage={'/main'} previousPage={'/main'}  isStep3={1}>
      {/*<NavigatorAdvanced leftFirstDivClassName={leftFirstDivClassName} leftSecondDivClassName={leftSecondDivClassName} leftTextSecondDivClassName={leftTextSecondDivClassName} leftLabelClassNameTittle={leftLabelClassNameTittle} leftLabelTextTittle={leftLabelTextTittle} leftLabelClassNameDescription={leftLabelClassNameDescription} leftLabelDescription={leftLabelDescription} centerFirstDivClassName={centerFirstDivClassName} centerSecondDivClassName={centerSecondDivClassName} centerTextSecondDivClassName={centerTextSecondDivClassName} centerLabelClassNameTittle={centerLabelClassNameTittle} centerLabelTextTittle={centerLabelTextTittle} centerLabelClassNameDescription={centerLabelClassNameDescription} centerLabelDescription={centerLabelDescription} rightFirstDivClassName={rightFirstDivClassName} rightSecondDivClassName={rightSecondDivClassName} rightTextSecondDivClassName={rightTextSecondDivClassName} rightLabelClassNameTittle={rightLabelClassNameTittle} rightLabelTextTittle={rightLabelTextTittle} rightLabelClassNameDescription={rightLabelClassNameDescription} rightLabelDescription={rightLabelDescription} leftBarClassName={leftBarClassName} rightBarClassName={rightBarClassName} parentState={parentState} setParentStateSteps={this.setStateGlobalStep}></NavigatorAdvanced>*/}
      <div>{coordPrev}</div>
      <div>{coords}</div>
      <div>{this.convers}</div>
      <button onClick={this.functionPost.bind(this)}>TEST</button>
      {/*<div className={stepClassName}>
          <section className={sectionClassName}>
            <div className="fifth-step">
              <Map setModal={this.setModal} setParentState={this.setStateGlobal} location={window.location} parentState={parentState} pluginList={pluginList} M={M} centerX={centerX} centerY={centerY} mapa={this.setMapa} isSimple={true}></Map>
            </div>
          </section>
      </div>*/}
    </LayoutAdvanced>);
  }
}

export default Step4;
